import { useEffect, useState } from "react";
import {
  useTagsQuery,
  useTeamsQuery,
} from "../../../../Services/settingsAPIs/CommonAPI";
import {
  useGetEmailRulesQuery,
  useSetEmailRulesCreateMutation,
  useSetEmailRulesMutation,
} from "../../../../Services/settingsAPIs/EmailConfiguration";
import { toast } from "react-toastify";
import { ReactMultiEmail } from "react-multi-email";
import ReactModal from "react-modal";
import AddEmailBasedLevel from "./AddEmailBasedLevel";
import DeleteLevelModal from "./DeleteLevelModal";

interface TimeValues {
  [key: string]: { hours: number; minutes: number };
}

const SLA = () => {
  const [theTeams, setTheTeams] = useState([]);
  const { data: teamsData } = useTeamsQuery({});
  const [selectedTeam, setSelectedTeam] = useState<number>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [theTags, setTheTags] = useState<any>([]);
  const [emailLists, setEmailLists] = useState({});
  const [levelEmailList, setLevelEmailList] = useState<any>({});
  const [timeValues, setTimeValues] = useState({});
  const [selectedLevelName, setSelectedLevelName] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentEscalationLevel, setCurrentEscalationLevel] = useState(1);
  const [updatedTimeValues, setUpdatedTimeValues] = useState({});
  const [updatedLevelTimeValues, setUpdatedLevelTimeValues] = useState({});
  const [selectedTag, setSelectedTag] = useState<any>(null);
  const [id, setId] = useState<any>(null);
  const [hasError, setHasError] = useState(false);
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  // Email validation function
  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const {
    data: emailRulesData,
    refetch,
    status,
  } = useGetEmailRulesQuery(selectedTeam, {
    skip: !selectedTeam,
  });
  const [ticketTagSLAEscalationLevels, setTicketTagSLAEscalationLevels] =
    useState<any>([]);
  const [triggerSetEmailRules] = useSetEmailRulesMutation();
  const [triggerSetEmailRulesCreate] = useSetEmailRulesCreateMutation();

  const customAddlevelModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "450px",
      maxWidth: "850px",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  const openModal = (tagIndex: number) => {
    const selected = theTags[tagIndex];
    setSelectedTag(selected);

    const existingLevelsCount = selected?.level
      ? Object.keys(selected.level).length
      : 1;

    if (existingLevelsCount >= 5) {
      toast.error("Limit exceeded! Maximum 5 escalation levels allowed.");
      return;
    }

    let availableLevels: any = new Set<number>();
    let minLevel = 2;

    if (selected?.level && Object.keys(selected?.level)?.length > 0) {
      const levels = Object.keys(selected.level)
        .map((level) => parseInt(level.match(/\d+/)?.[0] || "1", 10))
        .filter(Number.isFinite);

      const maxLevel = levels.length > 0 ? Math.max(...levels) + 1 : minLevel;
      for (let i = minLevel; i <= maxLevel; i++) {
        availableLevels.add(i);
      }
      levels.forEach((lvl) => availableLevels.delete(lvl));
    } else {
      availableLevels.add(minLevel);
    }
    setCurrentEscalationLevel(Math.min(...availableLevels));
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTag(null);
  };

  const openAddSLAModal = () => {
    if (!selectedTeam) {
      toast.error("Please select a team first");
      return;
    }
    setCurrentEscalationLevel(1);
    setSelectedTag({ team_id: selectedTeam });
    setIsModalOpen(true);
  };

  const openDeleteModal = (tagIndex: number, levelName: string) => {
    const selected = theTags[tagIndex];
    setSelectedTag(selected);
    setSelectedLevelName(levelName);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleSelectTeamChange = (event: any) => {
    setSelectedTeam(Number(event.target.value));
  };

  useEffect(() => {
    if (teamsData) setTheTeams(teamsData);
  }, [teamsData]);

  const handleTimeChangeLevel1 = (tagIndex, unit, action) => {
    const levelName = "Escalation Level 1";
    const key = `${tagIndex}-${levelName}`;

    setTimeValues((prev) => {
      const currentValue = prev[key] || { hours: 0, minutes: 0 };

      const updatedValue = {
        ...currentValue,
        [unit]:
          action === "increment"
            ? currentValue[unit] + 1
            : Math.max(currentValue[unit] - 1, 0),
      };

      setUpdatedLevelTimeValues((prevUpdates) => ({
        ...prevUpdates,
        [key]: { ...updatedValue },
      }));

      return { ...prev, [key]: { ...updatedValue } };
    });
  };

  const toggleExpansion = (index: number) => {
    setTheTags((prev) =>
      prev.map((tag, i) =>
        i === index ? { ...tag, showExpanded: !tag.showExpanded } : tag
      )
    );
  };

  const handleTimeChangeExpanded = (tagIndex, levelName, unit, action) => {
    const key = `${tagIndex}-${levelName}`;

    setTimeValues((prev) => {
      const currentValue = prev[key] || { hours: 0, minutes: 0 };
      const updatedValue = {
        ...currentValue,
        [unit]:
          action === "increment"
            ? currentValue[unit] + 1
            : Math.max(currentValue[unit] - 1, 0),
      };

      setUpdatedLevelTimeValues((prevUpdates) => ({
        ...prevUpdates,
        [key]: { ...updatedValue },
      }));

      return { ...prev, [key]: { ...updatedValue } };
    });
  };

  const handleTimeChange = (tagIndex, levelName, unit, action) => {
    if (levelName) {
      handleTimeChangeExpanded(tagIndex, levelName, unit, action);
    } else {
      handleTimeChangeLevel1(tagIndex, unit, action);
    }
  };

  // New unified save function that saves all changes
  const handleSaveAllChanges = async () => {
    if (!selectedTeam) {
      toast.error("Team ID is required");
      return;
    }

    setIsLoading(true);
    let anyUpdated = false;

    try {
      // Loop through all tags and all their levels
      for (let tagIndex = 0; tagIndex < theTags.length; tagIndex++) {
        const tag = theTags[tagIndex];

        // Check all levels for this tag
        const allLevels = [
          "Escalation Level 1",
          ...Object.keys(tag.level || {}).filter(
            (l) => l !== "Escalation Level 1"
          ),
        ];

        for (const levelName of allLevels) {
          const key = `${tagIndex}-${levelName}`;

          // Get the appropriate email list
          let updatedEmails;
          if (levelName === "Escalation Level 1") {
            updatedEmails = emailLists[tagIndex];
          } else {
            updatedEmails = levelEmailList[key];
          }

          const updatedTime = updatedLevelTimeValues[key];
          const originalData = tag.level?.[levelName] || {};
          const originalEmails = originalData.sla_mail || [];
          const originalDuration = originalData.duration_in_ms || 0;
          const originalHours = Math.floor(originalDuration / 3600000);
          const originalMinutes = Math.floor(
            (originalDuration % 3600000) / 60000
          );

          const previousTimeValues = timeValues[key] || {
            hours: 0,
            minutes: 0,
          };
          const finalHours =
            updatedTime?.hours !== undefined
              ? updatedTime.hours
              : previousTimeValues.hours;
          const finalMinutes =
            updatedTime?.minutes !== undefined
              ? updatedTime.minutes
              : previousTimeValues.minutes;
          const finalEmails =
            updatedEmails !== undefined
              ? [...updatedEmails]
              : [...originalEmails];

          // Check if there are changes
          const hasTimeChanges =
            finalHours !== originalHours || finalMinutes !== originalMinutes;
          const hasEmailChanges =
            JSON.stringify([...finalEmails].sort()) !==
            JSON.stringify([...originalEmails].sort());

          if (hasTimeChanges || hasEmailChanges) {
            anyUpdated = true;
            const durationInMs = finalHours * 3600000 + finalMinutes * 60000;

            const payload = {
              level: levelName,
              value: {
                sla_mail: finalEmails,
                duration_in_ms: durationInMs,
              },
            };

            await triggerSetEmailRules({
              body: payload,
              selectedTeam: selectedTeam,
            });
          }
        }
      }

      if (anyUpdated) {
        toast.success("All escalation levels updated successfully");
        // Clear all pending changes
        setUpdatedLevelTimeValues({});
        setEmailLists({});
        setLevelEmailList({});
        refetch();
      } else {
        toast.warn("No changes detected");
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error saving escalations:", error);
      toast.error("Failed to save escalations. Please try again.");
      setIsLoading(false);
    }
  };

  // Check if there are any changes across all levels
  const hasAnyChanges = () => {
    for (let tagIndex = 0; tagIndex < theTags.length; tagIndex++) {
      // Check Escalation Level 1
      if (hasLevel1Changes(tagIndex)) {
        return true;
      }

      // Check other levels
      const tag = theTags[tagIndex];
      const otherLevels = Object.keys(tag.level || {}).filter(
        (l) => l !== "Escalation Level 1"
      );
      for (const levelName of otherLevels) {
        if (hasLevelChanges(tagIndex, levelName)) {
          return true;
        }
      }
    }
    return false;
  };

  const hasLevel1Changes = (tagIndex) => {
    const levelName = "Escalation Level 1";
    const updatedTime = updatedLevelTimeValues[`${tagIndex}-${levelName}`];
    const updatedEmails = emailLists[tagIndex];

    const originalData = theTags[tagIndex]?.level?.[levelName] || {};
    const originalEmails = originalData.sla_mail || [];
    const originalDuration = originalData.duration_in_ms || 0;
    const originalHours = Math.floor(originalDuration / 3600000);
    const originalMinutes = Math.floor((originalDuration % 3600000) / 60000);

    let hasTimeChanges = false;
    if (updatedTime) {
      const currentHours =
        updatedTime?.hours !== undefined ? updatedTime?.hours : originalHours;
      const currentMinutes =
        updatedTime?.minutes !== undefined
          ? updatedTime?.minutes
          : originalMinutes;
      hasTimeChanges =
        currentHours !== originalHours || currentMinutes !== originalMinutes;
    }

    const hasEmailChanges =
      updatedEmails !== undefined &&
      JSON.stringify([...updatedEmails].sort()) !==
        JSON.stringify([...originalEmails].sort());

    return hasTimeChanges || hasEmailChanges;
  };

  const hasLevelChanges = (tagIndex, levelName) => {
    const key = `${tagIndex}-${levelName}`;
    const levelEmails = levelEmailList[key] || [];
    const updatedTime = updatedLevelTimeValues[key];

    const originalData = theTags[tagIndex]?.level?.[levelName] || {};
    const originalEmails = originalData.sla_mail || [];
    const originalDuration = originalData.duration_in_ms || 0;
    const originalHours = Math.floor(originalDuration / 3600000);
    const originalMinutes = Math.floor((originalDuration % 3600000) / 60000);

    let hasTimeChanges = false;
    if (updatedTime) {
      const currentHours =
        updatedTime?.hours !== undefined ? updatedTime?.hours : originalHours;
      const currentMinutes =
        updatedTime?.minutes !== undefined
          ? updatedTime?.minutes
          : originalMinutes;
      hasTimeChanges =
        currentHours !== originalHours || currentMinutes !== originalMinutes;
    }

    const hasEmailChanges =
      levelEmails?.length > 0 &&
      JSON.stringify([...levelEmails].sort()) !==
        JSON.stringify([...originalEmails].sort());

    return hasTimeChanges || hasEmailChanges;
  };

  useEffect(() => {
    if (
      Array.isArray(ticketTagSLAEscalationLevels) &&
      ticketTagSLAEscalationLevels.length > 0
    ) {
      const formattedTags = ticketTagSLAEscalationLevels.map((tag, index) => {
        let levelData = tag.level;
        if (!levelData) {
          const escalationLevelKeys = Object.keys(tag).filter((key) =>
            key.startsWith("Escalation Level")
          );
          if (escalationLevelKeys.length > 0) {
            levelData = {};
            escalationLevelKeys.forEach((key) => {
              levelData[key] = tag[key];
            });
          }
        }

        return {
          ...tag,
          level: levelData || {},
          showExpanded: theTags[index]?.showExpanded || false,
        };
      });

      setTheTags(formattedTags);

      const initialTimeValues: TimeValues = {};
      const initialEmailLists: any = {};

      formattedTags.forEach((tag: any, tagIndex) => {
        if (typeof tag.duration_in_ms === "number" && tag.duration_in_ms > 0) {
          initialTimeValues[tagIndex] = {
            hours: Math.floor(tag.duration_in_ms / 3600000),
            minutes: Math.floor((tag.duration_in_ms % 3600000) / 60000),
          };
        }
        Object.entries(tag.level || {}).forEach(
          ([levelName, levelData]: [string, any]) => {
            const duration =
              typeof levelData.duration_in_ms === "number"
                ? levelData.duration_in_ms
                : 0;
            initialTimeValues[`${tagIndex}-${levelName}`] = {
              hours: Math.floor(duration / 3600000),
              minutes: Math.floor((duration % 3600000) / 60000),
            };

            if (levelData.sla_mail && Array.isArray(levelData.sla_mail)) {
              initialEmailLists[`${tagIndex}-${levelName}`] = [
                ...levelData.sla_mail,
              ];
              if (levelName === "Escalation Level 1") {
                initialEmailLists[tagIndex] = [...levelData.sla_mail];
              }
            }
          }
        );
      });
      setTimeValues(initialTimeValues);
      setEmailLists(initialEmailLists);
      setLevelEmailList(initialEmailLists);
    } else {
      setTheTags([]);
      setTimeValues({});
      setEmailLists({});
      setLevelEmailList({});
    }
  }, [ticketTagSLAEscalationLevels]);

  useEffect(() => {
    if (emailRulesData) {
      if (
        emailRulesData.message &&
        emailRulesData.message ===
          "No Email SL configuration found for particular Team"
      ) {
        toast.error(emailRulesData.message);
        setTicketTagSLAEscalationLevels([]);
        return;
      }

      setHasError(false);

      if (Array.isArray(emailRulesData.level)) {
        setTicketTagSLAEscalationLevels(emailRulesData.level);
      } else if (
        emailRulesData.level &&
        typeof emailRulesData.level === "object" &&
        Object.keys(emailRulesData.level).length > 0
      ) {
        setTicketTagSLAEscalationLevels([emailRulesData.level]);
      } else {
        setTicketTagSLAEscalationLevels([]);
      }
    } else {
      setTicketTagSLAEscalationLevels([]);
      setHasError(false);
    }
  }, [emailRulesData]);

  useEffect(() => {
    if (status === "pending") {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [status]);

  return (
    <>
      <div
        className="card-toolbar flex-row-fluid justify-content-end gap-5 p-5"
        style={{ marginLeft: "3%", marginRight: "3%" }}
      >
        <div className="row">
          <div className="col">
            <span className="input-group-text mt-2" id="basic-addon1">
              First Response SL
            </span>
          </div>
        </div>

        <div className="row my-4">
          <div className="col-12">
            <div className="card-toolbar d-lg-flex gap-5 align-items-end">
              <div className="d-flex flex-column">
                <label>Select team</label>
                <div className="min-w-250px">
                  <select
                    className="form-select"
                    onChange={handleSelectTeamChange}
                    value={selectedTeam}
                  >
                    <option value="" disabled selected>
                      {" "}
                      Select team{" "}
                    </option>
                    {theTeams?.map((el: any) => (
                      <option value={el?.id} key={el?.id}>
                        {el?.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="ms-auto d-flex align-items-center gap-3">
                <i
                  className="bi bi-info-circle cursor-pointer text-primary"
                  onClick={() => setShowInfoPopup(true)}
                  style={{ fontSize: "24px" }}
                  title="Information"
                ></i>

                {selectedTeam &&
                  ticketTagSLAEscalationLevels &&
                  ticketTagSLAEscalationLevels.length === 0 &&
                  !hasError && (
                    <button
                      className="btn btn-sm btn-light-primary fw-bold"
                      onClick={openAddSLAModal}
                    >
                      <i className="bi bi-plus-lg me-2"></i>
                      <span>Add SL</span>
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>

        {ticketTagSLAEscalationLevels &&
          ticketTagSLAEscalationLevels.length > 0 && (
            <div style={{ marginLeft: "0%", marginTop: "1%" }}>
              <div className="row">
                <div className="col">
                  <div
                    className="card my-1 min-h-40px justify-content-center"
                    style={{ backgroundColor: "rgba(228, 228, 228, 0.498)" }}
                  >
                    <div className="row align-items-center">
                      <div className="col-2 text-center">
                        <strong>Escalation Level</strong>
                      </div>
                      <div className="col-2 text-center">
                        <strong>Hours</strong>
                      </div>
                      <div className="col-2 text-center">
                        <strong>Minutes</strong>
                      </div>
                      <div className="col-4 text-center">
                        <strong>Mail ID</strong>
                      </div>
                      <div className="col-2 text-center">
                        <strong>Actions</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {theTags.map((tagInfo: any, tagIndex: any) => (
                <div key={tagIndex}>
                  <div className="row">
                    <div className="col">
                      <div className="input-group-text mt-2 bg-white min-w-600px">
                        <div className="row w-100 align-items-center text-center">
                          <div className="col-2">Escalation Level 1</div>
                          <div className="col-2 d-flex align-items-center justify-content-center">
                            {timeValues[`${tagIndex}-Escalation Level 1`]
                              ?.hours || 0}
                            <div className="d-flex flex-column ms-2">
                              <i
                                className="bi bi-caret-up-fill cursor-pointer"
                                onClick={() => {
                                  handleTimeChange(
                                    tagIndex,
                                    "Escalation Level 1",
                                    "hours",
                                    "increment"
                                  );
                                  setId(tagInfo);
                                }}
                              ></i>
                              <i
                                className="bi bi-caret-down-fill cursor-pointer"
                                onClick={() => {
                                  handleTimeChange(
                                    tagIndex,
                                    "Escalation Level 1",
                                    "hours",
                                    "decrement"
                                  );
                                  setId(tagInfo);
                                }}
                              ></i>
                            </div>
                          </div>
                          <div className="col-2 d-flex align-items-center justify-content-center">
                            {timeValues[`${tagIndex}-Escalation Level 1`]
                              ?.minutes || 0}
                            <div className="d-flex flex-column ms-2">
                              <i
                                className="bi bi-caret-up-fill cursor-pointer"
                                onClick={() => {
                                  handleTimeChange(
                                    tagIndex,
                                    "Escalation Level 1",
                                    "minutes",
                                    "increment"
                                  );
                                  setId(tagInfo);
                                }}
                              ></i>
                              <i
                                className="bi bi-caret-down-fill cursor-pointer"
                                onClick={() => {
                                  handleTimeChange(
                                    tagIndex,
                                    "Escalation Level 1",
                                    "minutes",
                                    "decrement"
                                  );
                                  setId(tagInfo);
                                }}
                              ></i>
                            </div>
                          </div>

                          <div className="col-4">
                            <ReactMultiEmail
                              placeholder="Enter Email"
                              emails={
                                emailLists[tagIndex] ||
                                tagInfo.level?.["Escalation Level 1"]
                                  ?.sla_mail ||
                                []
                              }
                              onChange={(updatedEmails) => {
                                setEmailLists((prev) => ({
                                  ...prev,
                                  [tagIndex]: [...updatedEmails],
                                }));
                                setId(tagInfo);
                              }}
                              validateEmail={(email) => {
                                return isValidEmail(email);
                              }}
                              getLabel={(email, index, removeEmail) => (
                                <div data-tag key={index}>
                                  {email}
                                  <span
                                    data-tag-handle
                                    onClick={() => removeEmail(index)}
                                  >
                                    ×
                                  </span>
                                </div>
                              )}
                            />
                          </div>
                          <div className="col-2">
                            <div className="d-flex justify-content-center align-items-center gap-2 ms-11">
                              <button
                                type="button"
                                className="btn btn-link p-0 m-0 d-flex align-items-center justify-content-center"
                                onClick={() => openModal(tagIndex)}
                                title="Add Escalation Level"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  minWidth: "24px",
                                }}
                              >
                                <i className="text-dark bi bi-plus-lg fs-5"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-link text-danger p-0 m-0 d-flex align-items-center justify-content-center"
                                title="Delete Escalation Level 1"
                                onClick={() =>
                                  openDeleteModal(
                                    tagIndex,
                                    "Escalation Level 1"
                                  )
                                }
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  minWidth: "24px",
                                }}
                              >
                                <i className="bi bi-trash text-danger fs-5"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {Object.entries(tagInfo.level || {})
                    .filter(([levelName]) => levelName !== "Escalation Level 1")
                    .map(
                      ([levelName, levelData]: [string, any], levelIndex) => (
                        <div className="row" key={levelName}>
                          <div className="col">
                            <div className="input-group-text mt-2 bg-white min-w-600px">
                              <div className="row w-100 align-items-center text-center">
                                <div className="col-2 text-center">
                                  {levelName}
                                </div>
                                <div className="col-2 d-flex align-items-center justify-content-center">
                                  {timeValues[`${tagIndex}-${levelName}`]
                                    ?.hours || 0}
                                  <div className="d-flex flex-column ms-2">
                                    <i
                                      className="bi bi-caret-up-fill cursor-pointer"
                                      onClick={() => {
                                        handleTimeChange(
                                          tagIndex,
                                          levelName,
                                          "hours",
                                          "increment"
                                        );
                                        setId(tagInfo);
                                      }}
                                    ></i>
                                    <i
                                      className="bi bi-caret-down-fill cursor-pointer"
                                      onClick={() => {
                                        handleTimeChange(
                                          tagIndex,
                                          levelName,
                                          "hours",
                                          "decrement"
                                        );
                                        setId(tagInfo);
                                      }}
                                    ></i>
                                  </div>
                                </div>
                                <div className="col-2 d-flex align-items-center justify-content-center">
                                  {timeValues[`${tagIndex}-${levelName}`]
                                    ?.minutes || 0}
                                  <div className="d-flex flex-column ms-2">
                                    <i
                                      className="bi bi-caret-up-fill cursor-pointer"
                                      onClick={() => {
                                        handleTimeChange(
                                          tagIndex,
                                          levelName,
                                          "minutes",
                                          "increment"
                                        );
                                        setId(tagInfo);
                                      }}
                                    ></i>
                                    <i
                                      className="bi bi-caret-down-fill cursor-pointer"
                                      onClick={() => {
                                        handleTimeChange(
                                          tagIndex,
                                          levelName,
                                          "minutes",
                                          "decrement"
                                        );
                                        setId(tagInfo);
                                      }}
                                    ></i>
                                  </div>
                                </div>
                                <div className="col-4 text-center">
                                  <ReactMultiEmail
                                    placeholder="Enter Email"
                                    emails={
                                      levelEmailList[
                                        `${tagIndex}-${levelName}`
                                      ] ||
                                      levelData.sla_mail ||
                                      []
                                    }
                                    onChange={(updatedEmails) => {
                                      setLevelEmailList((prev) => ({
                                        ...prev,
                                        [`${tagIndex}-${levelName}`]: [
                                          ...updatedEmails,
                                        ],
                                      }));
                                      setId(tagInfo);
                                    }}
                                    validateEmail={(email) => {
                                      return isValidEmail(email);
                                    }}
                                    getLabel={(email, index, removeEmail) => (
                                      <div data-tag key={index}>
                                        {email}
                                        <span
                                          data-tag-handle
                                          onClick={() => removeEmail(index)}
                                        >
                                          ×
                                        </span>
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="col-2 text-center">
                                  <div className="d-inline-flex justify-content-center align-items-center gap-2 ms-20">
                                    <button
                                      type="button"
                                      className="btn btn-link text-danger p-0 m-0 d-flex align-items-center justify-content-center"
                                      title="Delete Escalation Level"
                                      onClick={() =>
                                        openDeleteModal(tagIndex, levelName)
                                      }
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                        minWidth: "24px",
                                      }}
                                    >
                                      <i className="bi bi-trash text-danger fs-5"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                </div>
              ))}

              {/* Save Button at Bottom */}
              <div className="row mt-4">
                <div className="col text-end">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveAllChanges}
                    disabled={!hasAnyChanges() || isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      "Save All Changes"
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        <ReactModal
          isOpen={isModalOpen}
          style={customAddlevelModalStyles}
          onRequestClose={closeModal}
          contentLabel="New Ticket"
        >
          <AddEmailBasedLevel
            closeModal={closeModal}
            currentEscalationLevel={currentEscalationLevel}
            refetch={refetch}
            selectedTag={selectedTag}
            teamId={selectedTeam}
          />
        </ReactModal>

        <ReactModal
          isOpen={isDeleteModalOpen}
          style={customModalStyles}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete level"
        >
          <DeleteLevelModal
            closeDeleteModal={closeDeleteModal}
            levelName={selectedLevelName}
            tagId={selectedTag?.tag_id}
            refetch={refetch}
            selectedSlaId={selectedTag?.sla_id}
            teamId={selectedTeam}
          />
        </ReactModal>
        {/* Info Popup Modal */}
        <ReactModal
          isOpen={showInfoPopup}
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              width: "450px",
              maxWidth: "90%",
              padding: "30px",
              borderRadius: "8px",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          }}
          onRequestClose={() => setShowInfoPopup(false)}
          contentLabel="Info"
        >
          <div className="d-flex flex-column">
            <div className="d-flex align-items-center mb-3">
              <i className="bi bi-info-circle text-primary fs-2 me-3"></i>
              <h5 className="mb-0">Information</h5>
            </div>
            <p className="mb-4" style={{ lineHeight: "1.6" }}>
              Configure tenant SMTP to send emails on SL breach. If no user
              email is set, the default email will be used.
            </p>
            <div className="text-end">
              <button
                className="btn btn-primary"
                onClick={() => setShowInfoPopup(false)}
              >
                Got it
              </button>
            </div>
          </div>
        </ReactModal>
      </div>
    </>
  );
};

export default SLA;
